/**
 * This file provides an `initAll` function that will trawl through the page,
 * pick up any modules it knows have associated JS, and will initialise the JS
 * class on that component. It will only do this if the component is explicitly
 * listed here, and only if it finds the component on the page, however it
 * loads the JS for *ALL* components, as they're all imported at once.
 *
 * You can keep JS filesizes small by creating different entry files that only
 * include the components needed for a page or section.
 *
 * This file also exports all component classes so that they can be initialized
 * individually, if necessary.
 *
 * `window.theNamespace.initAll()` (where `theNamespace` is the configured name
 * of the npm package.)
 */

import "what-input";

import Billing from "../../components/!pages/checkout/delivery/delivery";
import BusinessDetails from "../../components/!pages/my-account/business-details/business-details";
import CardPaymentSubscription from "../../components/!pages/my-account/my-subscription/subscription-payment-card/subscription-payment-card";
import Carousel from "../../components/carousel/carousel";
import DetailsGroup from "../../components/details-group/details-group";
import DDValidation from "../../components//!pages/checkout/payment/dd-only/dd-set-up";
import DDValidationReview from "../../components//!pages/checkout/payment/dd-only/dd-set-up-review";
import Select2 from "../../components/select2/select2";
import Header from "../../components/header/header";
import Gallery from "../../components/gallery/gallery";
import FileUpload from "../../components/file-upload/file-upload";
import FiltersSearch from "../../components/!pages/news/latest-news-opinion/latest-news-opinion";
import Filters from "../../components/filters/filters";
import MembershipType from "../../components/!pages/membership/membership-page";
import MultiSelect from "../../components/multi-select/multi-select";
import Modal from "../../components/modal/modal";
import Search from "../../components/search/search";
import SearchFilter from "../../components/search-filter/search-filter";
import Stepper from "../../components/stepper/stepper";
import SubNav from "../../components/sub-nav/sub-nav";
import SubscriptionCard from "../../components/subscription-card/subscription-card";
import PaymentWithCard from "../../components/!pages/checkout/payment/payment-with-card/payment-with-card";
import Tab from "../../components/tab/tab";
import Tooltip from "../../components/tooltip/tooltip";

function initAll(options) {
  // Scope initialization to only certain parts of the page
  // Defaults to entire document if not set
  options = typeof options !== "undefined" ? options : {};

  const scope = typeof options.scope !== "undefined" ? options.scope : document;
  let _;

  scope.querySelectorAll('[data-module="bc-billing"]').forEach((module) => {
    _ = new Billing(module);
  });
  scope
    .querySelectorAll('[data-module="ip-business-details-address"]')
    .forEach((module) => {
      _ = new BusinessDetails(module);
    });

  scope
    .querySelectorAll('[data-module="bc-card-payment-subscription"]')
    .forEach((module) => {
      _ = new CardPaymentSubscription(module);
    });
  scope.querySelectorAll('[data-module="bc-carousel"]').forEach((module) => {
    _ = new Carousel(module);
  });
  scope
    .querySelectorAll('[data-module="bc-dd-validation"]')
    .forEach((module) => {
      _ = new DDValidation(module);
    });
  scope
    .querySelectorAll('[data-module="bc-dd-validation-review"]')
    .forEach((module) => {
      _ = new DDValidationReview(module);
    });

  scope
    .querySelectorAll('[data-module="bc-details-group"]')
    .forEach((module) => {
      _ = new DetailsGroup(module);
    });
  scope.querySelectorAll('[data-module="bc-gallery"]').forEach((module) => {
    _ = new Gallery(module);
  });
  scope.querySelectorAll('[data-module="bc-header"]').forEach((module) => {
    _ = new Header(module);
  });

  scope.querySelectorAll('[data-module="bc-select2"]').forEach((module) => {
    _ = new Select2(module);
  });
  scope.querySelectorAll('[data-module="bc-filters"]').forEach((module) => {
    _ = new Filters(module);
  });
  scope
    .querySelectorAll('[data-module="bc-filters-search"]')
    .forEach((module) => {
      _ = new FiltersSearch(module);
    });
  scope.querySelectorAll('[data-module="bc-file-upload"]').forEach((module) => {
    _ = new FileUpload(module);
  });
  scope
    .querySelectorAll('[data-module="bc-membership-type"]')
    .forEach((module) => {
      _ = new MembershipType(module);
    });
  scope
    .querySelectorAll('[data-module="bc-multi-select"]')
    .forEach((module) => {
      _ = new MultiSelect(module);
    });
  scope.querySelectorAll('[data-module="bc-modal"]').forEach((module) => {
    _ = new Modal(module);
  });
  scope
    .querySelectorAll('[data-module="bc-payment-with-card"]')
    .forEach((module) => {
      _ = new PaymentWithCard(module);
    });

  scope.querySelectorAll('[data-module="bc-search"]').forEach((module) => {
    _ = new Search(module);
  });
  scope.querySelectorAll('[data-module="bc-search-filter"]').forEach((module) => {
    _ = new SearchFilter(module);
  });
  scope.querySelectorAll('[data-module="bc-stepper"]').forEach((module) => {
    _ = new Stepper(module);
  });
  scope.querySelectorAll('[data-module="bc-sub-nav"]').forEach((module) => {
    _ = new SubNav(module);
  });
  scope
    .querySelectorAll('[data-module="bc-subscription-card"]')
    .forEach((module) => {
      _ = new SubscriptionCard(module);
    });
  scope.querySelectorAll('[data-module="bc-tab"]').forEach((module) => {
    _ = new Tab(module);
  });
  scope.querySelectorAll('[data-module="bc-tooltip"]').forEach((module) => {
    _ = new Tooltip(module);
  });
}

export {
  initAll,
  CardPaymentSubscription,
  Billing,
  BusinessDetails,
  Carousel,
  DetailsGroup,
  DDValidation,
  DDValidationReview,
  Select2,
  FileUpload,
  Filters,
  FiltersSearch,
  Modal,
  MembershipType,
  MultiSelect,
  Gallery,
  Header,
  PaymentWithCard,
  SearchFilter,
  SubNav,
  SubscriptionCard,
  Stepper,
  Tab,
  Tooltip,
};
